<template>
  <el-alert :closable="retryable"
            :close-text="$t('ACTIONS.RETRY')"
            :description="description"
            :title="label"
            :type="type"
            @close="emit"
            effect="dark"
            show-icon>
  </el-alert>
</template>

<script>
export default {
  name: 'AppAlert',
  props: {
    type: {
      type: String,
      default: 'info'
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    retryable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emit () {
      this.$emit('retry')
    }
  }
}
</script>
